export const InsideFifaBackOfficePaths = {
    Root: '/inside-fifa',
    Players: '/inside-fifa/players',
    GenericTablesData: '/inside-fifa/generic-tables/data',
    GenericTablesConfigs: '/inside-fifa/generic-tables/configs',
};
